import Button from "../../components/Button.jsx";
import InputField from "../../components/InputField.jsx";

const AUTOFILL_DETECTION_STYLE = `
  @keyframes loginAutofillDetected {
    from {}
    to {}
  }

  #login-form input:-webkit-autofill {
    animation-name: loginAutofillDetected;
    animation-duration: 0.01s;
  }
`;

export default function LoginForm({
  formRef,
  usernameInputRef,
  passwordInputRef,
  username = "",
  password = "",
  errorMessage = "",
  isSubmitting = false,
  onCredentialFieldEvent,
  onUsernameChange,
  onPasswordChange,
  onSubmit,
}) {
  const hasError = Boolean(errorMessage);

  return (
    <form
      ref={formRef}
      id="login-form"
      className="flex w-full max-w-[454px] flex-col gap-7 rounded-xl border border-main-border-system-default bg-main-background-system-default p-6 font-ui"
      onSubmit={onSubmit}
    >
      <style>{AUTOFILL_DETECTION_STYLE}</style>
      <h2 className="text-center text-title font-semibold text-main-typography-system-default">
        ยินดีต้อนรับ
      </h2>

      <div className="flex flex-col gap-5">
        <InputField
          name="username"
          inputRef={usernameInputRef}
          label="ชื่อผู้ใช้"
          placeholder="ระบุชื่อผู้ใช้..."
          value={username}
          isRequired
          autoComplete="username"
          autoCapitalize="none"
          autoCorrect="off"
          onInput={onCredentialFieldEvent}
          onFocus={onCredentialFieldEvent}
          onAnimationStart={onCredentialFieldEvent}
          onChange={onUsernameChange}
          isError={hasError}
        />
        <InputField
          name="password"
          type="password"
          inputRef={passwordInputRef}
          label="รหัสผ่าน"
          placeholder="ระบุรหัสผ่าน..."
          value={password}
          isRequired
          autoComplete="current-password"
          autoCapitalize="none"
          autoCorrect="off"
          onInput={onCredentialFieldEvent}
          onFocus={onCredentialFieldEvent}
          onAnimationStart={onCredentialFieldEvent}
          onChange={onPasswordChange}
          errorText={errorMessage}
        />
      </div>

      <Button
        type="submit"
        size="md"
        text="ลงชื่อเข้าใช้"
        className="w-full"
        disabled={isSubmitting}
      />
    </form>
  );
}
